import styled, { css } from 'styled-components';
import { colors } from '../../utils/variables.styles';

const ModalContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  @media (max-width: 1150px) {
    justify-content: initial;
    gap: 20px;
  }
`;

const StyledImg = styled.img`
  display: block;
  width: 100px;
  height: 100px;
`;

const ColorContainer = styled.div`
  width: 50px;
  height: 50px;
  border: 0;
  background: ${colors.colorContainerBcg};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 2px;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const Color = styled.div`
  width: 50px;
  height: 50px;
  border: 1px solid black;
`;

const ColorWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const ItemContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'click'
})`
  display: flex;

  ${(props) => props.click && css`
    cursor: pointer;
  `};
`;

const ColorName = styled.div`
  display: flex;
  align-items: center;

  ${(props) => props.selected && css`
    font-weight: bold;
  `};
`;

export {
  ModalContainer,
  StyledImg,
  ColorContainer,
  Color,
  ColorWrapper,
  ItemContainer,
  ColorName
};
